import {Box, Checkbox, SxProps, Typography} from '@mui/material';
import React from 'react';
import {Control, Controller, FieldValues} from 'react-hook-form';

interface Props {
  control: Control<FieldValues>;
  name: string;
  label?: string | null;
  handleAdditionalOnChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  defaultValue?: boolean;
  sx?: SxProps;
}

const FormCheckbox: React.FC<Props> = ({
  control,
  name,
  label,
  handleAdditionalOnChange,
  defaultValue,
  sx,
}) => (
  <Box
    sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', ...sx}}>
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue ?? false}
      render={({field}) => (
        <Checkbox
          onChange={e => {
            field.onChange(e.target.checked);
            if (handleAdditionalOnChange) {
              handleAdditionalOnChange(e);
            }
          }}
          checked={field.value ?? false}
        />
      )}
    />
    {!!label && <Typography variant="body1">{label}</Typography>}
  </Box>
);

export default React.memo(FormCheckbox);
